import React from 'react';
import { Link } from 'react-router-dom';
import styles from './montador_da_017.module.scss';

import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const WHATSAPP_URL = 'https://wa.me/5517997146547';
const INSTAGRAM_URL =
    'https://www.instagram.com/montador_da_017?igsi=MWNlMzlwb3k1eDBjcQ%3D%3D&utm_source=qr';

const Montador_da_017: React.FC = () => {
    return (
        <div className={styles.page}>
            <div className={styles.montador_da_017}>
                <div className={styles.container}>
                    <div className={styles.infoSection}>
                        <div className={styles.links}>
                            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                                <WhatsappIcon height="30" color="#ffffff" />
                                WHATSAPP
                            </a>
                            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
                                <InstagramIcon height="24" color="#ffffff" />
                                INSTAGRAM
                            </a>
                            <Link to="/montador_da_017/servicos">
                                <CatalogIcon height="24" color="#ffffff" />
                                SERVIÇOS
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Montador_da_017;
